'use strict';
var graphicsHelper = require('../../helper/graphicsHelper');
var React = require('react');
var ReactDOM = require('react-dom');
var GlobalConst = require('../../types/GlobalConst');

/**
 * 可进行图片颜色变化的组件
 */
var ColorImage = React.createClass({

  propTypes: {
    src: React.PropTypes.string.isRequired,
    color: React.PropTypes.string,
    gridRect: React.PropTypes.object,
    style: React.PropTypes.object
  },

  render: function () {
    var sw = this.props.style ? this.props.style.width : (this.props.width || '100%');
    var sh = this.props.style ? this.props.style.height : (this.props.height || '100%');
    var style = this.props.style;

    if (!style) {
      style = {};
    }
    return (
      <canvas
        key={this.props.k}
        ref="ctx"
        width={sw}
        height={sh}
        style={style}>
        <img
          ref="img"
          src={this.props.src}
          style={{
            width: sw,
            height: sh,
            visibility: 'hidden'
          }}
          onLoad={this._onImageLoaded}
        />
      </canvas>

    );
  },

  componentDidMount: function () {
    this.isChanged = true;
    this.doPaint();
  },

  shouldComponentUpdate: function (newProps) {
    this.isChanged = false;
    if (this.props.src !== newProps.src) {
      this.isChanged = true;
    } else if (this.props.color !== newProps.color) {
      this.isChanged = true;
    } else if (JSON.stringify(this.props.style) !== JSON.stringify(newProps.style)) {
      this.isChanged = true;
    }

    return this.isChanged;
  },

  componentDidUpdate: function () {
    //if (this.isChanged) {
    this.doPaint();
    this.isChanged = false;
    //}
  },

  _onImageLoaded: function () {
    this.isLoaded = true;
    this.doPaint();
  },

  isChanged: true,

  doPaint: function () {
    var gridRect = this.props.gridRect;
    var color = this.props.color || GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR;
    var canvas = ReactDOM.findDOMNode(this.refs.ctx);
    var img = ReactDOM.findDOMNode(this.refs.img);
    var w = 0;
    var h = 0;
    if (!this.isChanged) {
      return;
    }
    if (canvas && img) {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
    } else {
      return;
    }

    //这里显示的强制再设置一次Canvas的width,height
    //Canvas的width,height必须要为明确的像素值，而不能是相对的百分比
    canvas.width = w;
    canvas.height = h;

    graphicsHelper
      .drawColorImage(canvas.getContext('2d'),
        img,
        color,
        gridRect,
        {
          left: 0,
          top: 0,
          right: w,
          bottom: h
        });
  }
});

module.exports = ColorImage;


// WEBPACK FOOTER //
// ./src/views/common/ColorImage.jsx